const LOGO_URL = 'https://storage.readdy-site.link/project_files/78577c8f-fc18-41aa-a1d2-c9f8c54ee764/78623651-928a-4a6c-9696-e83a35e6db95_13191140.jpg?v=33ccac5c6e145a69a497b2044c26fbdd';

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-white text-[#1A1A1A]">
      {/* Top gold accent bar */}
      <div className="h-1 w-full" style={{ background: 'linear-gradient(90deg, #B8956A, #C9A87C, #B8956A)' }}></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-14 border-b border-[#EDEAE5]">

          {/* Brand */}
          <div>
            <div className="mb-7">
              <img
                src={LOGO_URL}
                alt="Culp Home Improvement LLC"
                className="h-16 w-auto object-contain"
                style={{ maxWidth: '200px' }}
              />
            </div>

            <p
              className="text-[#666] text-sm leading-relaxed mb-8"
              style={{ fontFamily: 'Lora, serif' }}
            >
              Precision home remodeling built to elevate your space. Serving Johnston, IA and surrounding communities with quality craftsmanship.
            </p>

            <div className="flex gap-2.5 mb-7">
              {[
                { icon: 'ri-facebook-fill', href: 'https://www.facebook.com/culphomeimprovement', label: 'Facebook' },
                { icon: 'ri-google-fill', href: 'https://maps.app.goo.gl/2pDs7Vur2CXBdE13A', label: 'Google' },
                { icon: 'ri-instagram-fill', href: 'https://www.instagram.com/culphomeimprovement/', label: 'Instagram' },
              ].map((s, i) => (
                <a
                  key={i}
                  href={s.href}
                  rel="nofollow noopener"
                  target="_blank"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center bg-[#F5F2EE] hover:bg-[#B8956A] text-[#555] hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>

            {/* BBB badge */}
            <a
              href="https://www.bbb.org/us/ia/johnston/profile/basement-remodeling/culp-home-improvement-llc-0664-32056833/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 border border-[#E0D8D0] px-4 py-2.5 hover:border-[#B8956A] transition-colors"
            >
              <i className="ri-shield-star-fill text-[#B8956A] text-base"></i>
              <span className="text-[#555] text-xs font-semibold" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                BBB Accredited Business
              </span>
            </a>
          </div>

          {/* Navigation */}
          <div>
            <h4
              className="font-bold text-[11px] uppercase tracking-[0.22em] mb-7 text-[#1A1A1A]"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              <a href="#services">Quick Links</a>
            </h4>
            <ul className="space-y-3.5">
              {[
                { label: 'Our Services', id: 'services' },
                { label: 'Our Process', id: 'process' },
                { label: 'Why Choose Us', id: 'about' },
                { label: 'Service Areas', id: 'about' },
                { label: 'Testimonials', id: 'contact' },
                { label: 'Get a Free Estimate', id: 'contact' },
              ].map((item, i) => (
                <li key={i}>
                  <button
                    onClick={() => scrollTo(item.id)}
                    className="flex items-center gap-2 text-[#777] hover:text-[#B8956A] text-sm transition-colors duration-200 cursor-pointer group"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    <i className="ri-arrow-right-s-line text-transparent group-hover:text-[#B8956A] transition-colors text-xs"></i>
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4
              className="font-bold text-[11px] uppercase tracking-[0.22em] mb-7 text-[#1A1A1A]"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              <a href="#contact">Contact Us</a>
            </h4>
            <div className="space-y-5">
              <a href="tel:5153215711" className="flex items-center gap-3.5 group">
                <div className="w-9 h-9 flex items-center justify-center bg-[#B8956A]/10 flex-shrink-0">
                  <i className="ri-phone-fill text-[#B8956A] text-sm"></i>
                </div>
                <div>
                  <p className="text-[#aaa] text-[10px] uppercase tracking-widest mb-0.5" style={{ fontFamily: 'Montserrat, sans-serif' }}>Phone</p>
                  <span className="text-[#333] group-hover:text-[#B8956A] text-sm transition-colors font-medium" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    515-321-5711
                  </span>
                </div>
              </a>
              <a href="mailto:adam@culphomeimprovement.com" className="flex items-center gap-3.5 group">
                <div className="w-9 h-9 flex items-center justify-center bg-[#B8956A]/10 flex-shrink-0">
                  <i className="ri-mail-fill text-[#B8956A] text-sm"></i>
                </div>
                <div>
                  <p className="text-[#aaa] text-[10px] uppercase tracking-widest mb-0.5" style={{ fontFamily: 'Montserrat, sans-serif' }}>Email</p>
                  <span className="text-[#333] group-hover:text-[#B8956A] text-sm transition-colors break-all" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    adam@culphomeimprovement.com
                  </span>
                </div>
              </a>
              <div className="flex items-start gap-3.5">
                <div className="w-9 h-9 flex items-center justify-center bg-[#B8956A]/10 flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-fill text-[#B8956A] text-sm"></i>
                </div>
                <div>
                  <p className="text-[#aaa] text-[10px] uppercase tracking-widest mb-0.5" style={{ fontFamily: 'Montserrat, sans-serif' }}>Address</p>
                  <span className="text-[#333] text-sm leading-relaxed" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    PO Box 414<br />Johnston, IA 50131
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[#aaa] text-xs" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            &copy; 2026 Culp Home Improvement LLC. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a
              href="https://culphomeimprovement.com/privacy-policy/"
              rel="nofollow noopener"
              target="_blank"
              className="text-[#aaa] hover:text-[#B8956A] text-xs transition-colors"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Privacy Policy
            </a>
            <a
              href="https://culphomeimprovement.com/sitemap/"
              rel="nofollow noopener"
              target="_blank"
              className="text-[#aaa] hover:text-[#B8956A] text-xs transition-colors"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Sitemap
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
